import {
  PLUGIN_NAME,
} from '../utils-functions';

import Lightbox from '../Lightbox';
import {
  definePlugin,
} from '../../../define-plugin';

definePlugin(PLUGIN_NAME, ($el, methodOrOptions) => {
  return new Lightbox($el, methodOrOptions);
});
